import Vue from "vue";
import Router from "vue-router";
import AuthService from "../service/AuthService";
// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views - admin
const TrangChu = () => import("@/views/admin/Dashboard/TrangChu");

// Đăng ký dòng họ
const DanhSachDangKyDongHo = () =>
  import("@/views/admin/DangKy/DanhSachDangKyDongHo");
const DuyetDangKyDongHo = () =>
  import("@/views/admin/DangKy/DuyetDangKyDongHo");
const ChiTietDangKyDongHo = () =>
  import("@/views/admin/DangKy/DuyetDangKyDongHo");
// User
const DanhSachUserDongHo = () => import("@/views/admin/LdpUser/LdpUserDongHo");
const FormUser = () => import("@/views/admin/LdpUser/LdpFormUser");
const DanhSachUserSale = () => import("@/views/admin/LdpUser/LdpUserSale");
const DanhSachUserCTV = () => import("@/views/admin/LdpUser/LdpUserContent");
const DanhSachChamSocKhachHang = () =>
  import("@/views/admin/LdpUser/LdpUserChamSocKhachHang");
const DanhSachUserThietKe = () =>
  import("@/views/admin/LdpUser/LdpUserThietKe");

// Lời nhắn
const DanhSachLoiNhan = () => import("@/views/admin/LdpLoiNhan/LdpLoiNhan");
const FormLoiNhan = () => import("@/views/admin/LdpLoiNhan/LdpFormLoiNhan");

// Dòng họ
const DanhSachDongHo = () => import("@/views/admin/LdpDongHo/LdpDongHo");
const FormDongHo = () => import("@/views/admin/LdpDongHo/LdpFormDongHo");
const CayGiaPha = () => import("@/views/admin/LdpDongHo/CayGiaPha");

// Nốt gia phả
const NodeGiaPha = () => import("@/views/admin/NodeGiaPha/NodeGiaPha");
const FormNodeGiaPha = () => import("@/views/admin/NodeGiaPha/FormNodeGiaPha");

// Bài viết
const FormBaiViet = () => import("@/views/admin/BaiViet/LdpFormBaiViet");
const DanhSachBaiViet = () => import("@/views/admin/BaiViet/LdpBaiViet");

// Đánh giá
const DanhSachDanhGia = () => import("@/views/admin/LdpDanhGia/LdpDanhGia");
const FormDanhGia = () => import("@/views/admin/LdpDanhGia/LdpFormDanhGia");

// Slide
const DanhSachSlide = () => import("@/views/admin/LdpSlide/LdpDanhSachSlide");
const FormSlide = () => import("@/views/admin/LdpSlide/LdpFormSlide");

// Cấu hình
const DanhSachCauHinh = () => import("@/views/admin/LdpCauHinh/LdpCauHinh");
const FormCauHinh = () => import("@/views/admin/LdpCauHinh/LdpFormCauHinh");

// Thanh toán
const DanhSachThanhToan = () =>
  import("@/views/admin/ThanhToan/DanhSachThanhToan");
const FormThanhToan = () => import("@/views/admin/ThanhToan/FormThanhToan");

// Đơn hàng
const DanhSachDonHang = () => import("@/views/admin/DonHang/DonHang");
const FormDonHang = () => import("@/views/admin/DonHang/FormDonHang");

// Gói dịch vụ
const DanhSachGoiDichVu = () =>
  import("@/views/admin/PrdGoiDichVu/DanhSachPrdGoiDichVu");
const FormGoiDichVu = () =>
  import("@/views/admin/PrdGoiDichVu/FormPrdGoiDichVu");

// Phiếu thanh toán
const DanhSachPhieuThanhToan = () =>
  import("@/views/admin/PhieuThanhToan/DanhSachPhieuThanhToan");
const FormPhieuThanhToan = () =>
  import("@/views/admin/PhieuThanhToan/FormPhieuThanhToan");

// Bản in
const BanIn = () => import("@/views/admin/BanIn/DanhSachBanIn");
const FormBanIn = () => import("@/views/admin/BanIn/FormBanInn");

// Thông báo
const DanhSachThongBao = () =>
  import("@/views/admin/ThongBao/DanhSachThongBao");
const FormThongBao = () => import("@/views/admin/ThongBao/FormThongBao");

// Chính sách
const DanhSachChinhSach = () =>
  import("@/views/admin/ChinhSach/DanhSachChinhSach");
const FormChinhSach = () => import("@/views/admin/ChinhSach/FormChinhSach");

// Câu hỏi
const DanhSachCauHoi = () =>
  import("@/views/admin/CauHoiThuongGap/DanhSachCauHoi");
const FormCauHoi = () => import("@/views/admin/CauHoiThuongGap/FormCauHoi");

// Phương thức thanh toán
const DanhSachPhuongThucThanhToan = () =>
  import("@/views/admin/PhuongThucThanhToan/PhuongThucThanhToan");
const FormPhuongThucThanhToan = () =>
  import("@/views/admin/PhuongThucThanhToan/FormPhuongThucThanhToan");

// QR Scan
const DanhSachQRScan = () => import("@/views/admin/QRScan/QRScan");
const FormQRScan = () => import("@/views/admin/QRScan/FormQRScan");

// Cấp đại lý
const DanhSachCapDaiLy = () =>
  import("@/views/admin/DaiLy/CapDaiLy/DanhSachCapDaiLy");
const FormCapDaiLy = () => import("@/views/admin/DaiLy/CapDaiLy/FormCapDaiLy");

// Đại lý
const DanhSachDaiLy = () =>
  import("@/views/admin/DaiLy/DanhSachDaiLy/DanhSachDaiLy.vue");
const FormDaiLy = () =>
  import("@/views/admin/DaiLy/DanhSachDaiLy/FormDaiLy.vue");

// Sản phẩm
const DanhSachSanPham = () => import("@/views/admin/SanPham/DanhSachSanPham");
const FormSanPham = () => import("@/views/admin/SanPham/FormSanPham");

// Mail
const DanhSachMail = () => import("@/views/admin/Mail/TemplateMail");
const MailForm = () => import("@/views/admin/Mail/MailForm");

// Views - auth
const AuthPage404 = () => import("@/views/auth/Page404");
const AuthLogin = () => import("@/views/auth/Login");
const AuthRecoverPassword = () => import("@/views/auth/RecoverPassword");
const AuthResetPassword = () => import("@/views/auth/ResetPassword");
const AuthTimeOut = () => import("@/views/auth/SessionTimeOut");

Vue.use(Router);

const router = new Router({
  base: window.MyConfig.pathDefault,
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: [
    {
      path: "/admin",
      redirect: "/admin/trang-chu",
      component: DefaultContainer,
      children: [
        {
          path: "trang-chu",
          name: "Admin-Home",
          component: TrangChu,
          meta: {
            allowAccess: ["SystemAdmin", "ContentAdmin", "SalesUser"],
            page: "admin",
          },
        },
        {
          path: "dang-ky-dong-ho",
          name: "DangKyDongHo",
          redirect: "/admin/dang-ky-dong-ho/danh-sach-dang-ky-dong-ho",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-dang-ky-dong-ho",
              name: "DanhSachDangKyDongHo",
              component: DanhSachDangKyDongHo,
              meta: {
                allowAccess: ["SystemAdmin", "CustomerCareUser"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-dang-ky-dong-ho/chi-tiet-dang-ky-dong-ho/:id",
              name: "ChiTietDangKyDongHo",
              component: ChiTietDangKyDongHo,
              meta: {
                allowAccess: ["SystemAdmin", "CustomerCareUser"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-dang-ky-dong-ho/duyet-dang-ky-dong-ho/:id",
              name: "DuyetDangKyDongHo",
              component: DuyetDangKyDongHo,
              meta: {
                allowAccess: ["SystemAdmin", "CustomerCareUser"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "dong-ho",
          name: "DongHo",
          redirect: "/admin/dong-ho/danh-sach-dong-ho",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-dong-ho",
              name: "DanhSachDongHo",
              component: DanhSachDongHo,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-dong-ho/chi-tiet/:id",
              name: "ChiTietDongHo",
              component: FormDongHo,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-dong-ho/cay-gia-pha/:id",
              name: "CayGiaPha",
              component: CayGiaPha,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-dong-ho/cap-nhat/:id",
              name: "CapNhatDongHo",
              component: FormDongHo,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-dong-ho/them-moi-dong-ho",
              name: "ThemDongHo",
              component: FormDongHo,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "node-gia-pha",
          name: "NodeGiaPha",
          redirect: "/admin/node-gia-pha/danh-sach-node-gia-pha",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-node-gia-pha/:id",
              name: "DanhSachNodeGiaPha",
              component: NodeGiaPha,
              meta: {
                allowAccess: ["SystemAdmin", "FamilyAdmin", "FamilyUser"],
                page: "admin",
              },
            },
            {
              path: "chi-tiet/:nguoi_dung_id",
              name: "ChiTietNodeGiaPha",
              component: FormNodeGiaPha,
              meta: {
                allowAccess: ["SystemAdmin", "FamilyAdmin", "FamilyUser"],
                page: "admin",
              },
            },
            {
              path: "cap-nhat/:nguoi_dung_id",
              name: "CapNhatNodeGiaPha",
              component: FormNodeGiaPha,
              meta: {
                allowAccess: ["SystemAdmin", "FamilyAdmin", "FamilyUser"],
                page: "admin",
              },
            },
            {
              path: "them-moi-node-gia-pha",
              name: "ThemNodeGiaPha",
              component: FormNodeGiaPha,
              meta: {
                allowAccess: ["SystemAdmin", "FamilyAdmin", "FamilyUser"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "danh-gia",
          name: "DanhGia",
          redirect: "/admin/danh-gia/danh-sach-danh-gia",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-danh-gia",
              name: "DanhSachDanhGia",
              component: DanhSachDanhGia,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-danh-gia/chi-tiet/:id",
              name: "ChiTietDanhGia",
              component: FormDanhGia,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-danh-gia/cap-nhat/:id",
              name: "CapNhatDanhGia",
              component: FormDanhGia,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-danh-gia/them-moi-danh-gia",
              name: "ThemDanhGia",
              component: FormDanhGia,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "loi-nhan",
          name: "LoiNhan",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-loi-nhan",
              name: "DanhSachLoiNhan",
              component: DanhSachLoiNhan,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-loi-nhan/chi-tiet/:id",
              name: "FormLoiNhan",
              component: FormLoiNhan,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "bai-viet",
          name: "BaiViet",
          redirect: "/admin/bai-viet/danh-sach-bai-viet",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-bai-viet",
              name: "DanhSachBaiViet",
              component: DanhSachBaiViet,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-bai-viet/them-moi-bai-viet",
              name: "TaoBaiViet",
              component: FormBaiViet,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-bai-viet/chi-tiet/:id",
              name: "BaiVietChiTiet",
              component: FormBaiViet,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-bai-viet/cap-nhat/:id",
              name: "CapNhatBaiViet",
              component: FormBaiViet,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "dai-ly",
          name: "CapDaiLy",
          redirect: "/admin/dai-ly/cap-dai-ly",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cap-dai-ly",
              name: "DanhSachCapDaiLy",
              component: DanhSachCapDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "cap-dai-ly/them-moi-cap-dai-ly",
              name: "TaoCapDaiLy",
              component: FormCapDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "cap-dai-ly/chi-tiet/:id",
              name: "CapDaiLyChiTiet",
              component: FormCapDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "cap-dai-ly/cap-nhat/:id",
              name: "CapNhatCapDaiLy",
              component: FormCapDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "dai-ly",
          name: "QuanLyDaiLy",
          redirect: "/admin/dai-ly/danh-sach-dai-ly",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-dai-ly",
              name: "DanhSachDaiLy",
              component: DanhSachDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "them-moi-dai-ly",
              name: "ThemMoiDaiLy",
              component: FormDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "chi-tiet/:id",
              name: "ChiTietDaiLy",
              component: FormDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "cap-nhat/:id",
              name: "CapNhatDaiLy",
              component: FormDaiLy,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },

        {
          path: "slide",
          redirect: "/admin/slide/danh-sach-slide",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-slide",
              name: "DanhSachSlide",
              component: DanhSachSlide,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin", "User"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-slide/chi-tiet/:id",
              name: "ChiTietSlide",
              component: FormSlide,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin", "User"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-slide/cap-nhat/:id",
              name: "CapNhatSlide",
              component: FormSlide,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-slide/them-moi-slide",
              name: "ThemSlide",
              component: FormSlide,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "cau-hinh",
          redirect: "/admin/cau-hinh/danh-sach-cau-hinh",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-cau-hinh",
              name: "DanhSachCauHinh",
              component: DanhSachCauHinh,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-cau-hinh/chi-tiet/:id",
              name: "ChiTietCauHinh",
              component: FormCauHinh,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-cau-hinh/cap-nhat/:id",
              name: "CapNhatCauHinh",
              component: FormCauHinh,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-cau-hinh/them-moi-cau-hinh",
              name: "ThemCauHinh",
              component: FormCauHinh,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "user",
          name: "NguoiDung",
          redirect: "/admin/user/danh-sach-user",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-user",
              name: "DanhSachNguoiDung",
              component: DanhSachUserDongHo,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-user/chi-tiet/:id",
              name: "ChiTietNguoiDung",
              component: FormUser,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-user/cap-nhat/:id",
              name: "CapNhatNguoiDung",
              component: FormUser,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "user/them-moi-tai-khoan",
          name: "ThemMoiNguoiDung",
          component: FormUser,
          meta: {
            allowAccess: ["SystemAdmin"],
            page: "admin",
          },
        },

        {
          path: "don-hang",
          name: "DonHang",
          redirect: "/admin/don-hang/danh-sach-don-hang",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-don-hang",
              name: "DanhSachDonHang",
              component: DanhSachDonHang,
              meta: {
                allowAccess: ["SystemAdmin", "SalesUser"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-don-hang/chi-tiet/:id",
              name: "ChiTietDonHang",
              component: FormDonHang,
              meta: {
                allowAccess: ["SystemAdmin", "SalesUser"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-don-hang/cap-nhat/:id",
              name: "CapNhatDonHang",
              component: FormDonHang,
              meta: {
                allowAccess: ["SystemAdmin", "SalesUser"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-don-hang/them-moi-don-hang",
              name: "ThemDonHang",
              component: FormDonHang,
              meta: {
                allowAccess: ["SystemAdmin", "SalesUser"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "ban-in",
          name: "BanIn",
          redirect: "/admin/ban-in",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-ban-in",
              name: "DanhSachBanIn",
              component: BanIn,
              meta: {
                allowAccess: [
                  "SystemAdmin",
                  "SalesManager",
                  "InGiaPhaSales",
                  "CustomerCareUser",
                  "InGiaPhaDesigner",
                ],
                page: "admin",
              },
            },
            {
              path: "danh-sach-ban-in/chi-tiet/:id",
              name: "ChiTietBanIn",
              component: FormBanIn,
              meta: {
                allowAccess: [
                  "SystemAdmin",
                  "SalesManager",
                  "InGiaPhaSales",
                  "CustomerCareUser",
                  "InGiaPhaDesigner",
                ],
                page: "admin",
              },
            },
            {
              path: "danh-sach-ban-in/cap-nhat/:id",
              name: "CapNhatBanIn",
              component: FormBanIn,
              meta: {
                allowAccess: [
                  "SystemAdmin",
                  "SalesManager",
                  "InGiaPhaSales",
                  "CustomerCareUser",
                  "InGiaPhaDesigner",
                ],
                page: "admin",
              },
            },
            {
              path: "danh-sach-ban-in/them-moi-ban-in",
              name: "ThemMoiBanIn",
              component: FormBanIn,
              meta: {
                allowAccess: ["SystemAdmin", "SalesManager", "InGiaPhaSales"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "goi-dich-vu",
          name: "GoiDichVu",
          redirect: "/admin/goi-dich-vu",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-goi-dich-vu",
              name: "DanhSachGoiDichVu",
              component: DanhSachGoiDichVu,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-goi-dich-vu/chi-tiet/:id",
              name: "ChiTietGoiDichVu",
              component: FormGoiDichVu,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-goi-dich-vu/cap-nhat/:id",
              name: "CapNhatGoiDichVu",
              component: FormGoiDichVu,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "them-moi-goi-dich-vu",
              name: "ThemMoiGoiDichVu",
              component: FormGoiDichVu,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "phieu-thanh-toan",
          name: "PhieuThanhToan",
          redirect: "/admin/phieu-thanh-toan",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-phieu-thanh-toan-viettoc",
              name: "DanhSachPhieuThanhToanVietToc",
              component: DanhSachPhieuThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-phieu-thanh-toan-dai-ly",
              name: "DanhSachPhieuThanhToanDaiLy",
              component: DanhSachPhieuThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-phieu-thanh-toan/chi-tiet/:id",
              name: "ChiTietPhieuThanhToan",
              component: FormPhieuThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "them-moi-phieu-thanh-toan",
              name: "ThemMoiPhieuThanhToan",
              component: FormPhieuThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "chinh-sach",
          name: "ChinhSach",
          redirect: "/admin/chinh-sach/danh-sach-chinh-sach",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-chinh-sach",
              name: "DanhSachChinhSach",
              component: DanhSachChinhSach,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-chinh-sach/chi-tiet/:id",
              name: "ChiTietChinhSach",
              component: FormChinhSach,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-chinh-sach/cap-nhat/:id",
              name: "CapNhatChinhSach",
              component: FormChinhSach,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-chinh-sach/them-moi-chinh-sach",
              name: "ThemMoiChinhSach",
              component: FormChinhSach,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "phuong-thuc-thanh-toan",
          name: "PhuongThucThanhToan",
          redirect:
            "/admin/phuong-thuc-thanh-toan/danh-sach-phuong-thuc-thanh-toan",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-phuong-thuc-thanh-toan",
              name: "DanhSachPhuongThucThanhToan",
              component: DanhSachPhuongThucThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-phuong-thuc-thanh-toan/chi-tiet/:id",
              name: "ChiTietPhuongThucThanhToan",
              component: FormPhuongThucThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-phuong-thuc-thanh-toan/cap-nhat/:id",
              name: "CapNhatPhuongThucThanhToan",
              component: FormPhuongThucThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-phuong-thuc-thanh-toan/them-moi-phuong-thuc-thanh-toan",
              name: "ThemMoiPhuongThucThanhToan",
              component: FormPhuongThucThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "cau-hoi",
          name: "CauHoi",
          redirect: "/admin/cau-hoi/danh-sach-cau-hoi",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-cau-hoi",
              name: "DanhSachCauHoi",
              component: DanhSachCauHoi,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-cau-hoi/chi-tiet/:id",
              name: "ChiTietCauHoi",
              component: FormCauHoi,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-cau-hoi/cap-nhat/:id",
              name: "CapNhatCauHoi",
              component: FormCauHoi,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-cau-hoi/them-moi-cau-hoi",
              name: "ThemMoiCauHoi",
              component: FormCauHoi,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "user/danh-sach-sale",
          name: "DanhSachSale",
          component: DanhSachUserSale,
          meta: {
            allowAccess: ["SystemAdmin", "SalesUser"],
            page: "admin",
          },
        },
        {
          path: "user/danh-sach-quan-tri-noi-dung",
          name: "DanhSachCTV",
          component: DanhSachUserCTV,
          meta: {
            allowAccess: ["SystemAdmin", "ContentAdmin"],
            page: "admin",
          },
        },
        {
          path: "user/danh-sach-thiet-ke",
          name: "DanhSachThietKe",
          component: DanhSachUserThietKe,
          meta: {
            allowAccess: ["SystemAdmin", "InGiaPhaDesigner"],
            page: "admin",
          },
        },
        {
          path: "user/danh-sach-cham-soc-khach-hang",
          name: "DanhSachChamSocKhachHang",
          component: DanhSachChamSocKhachHang,
          meta: {
            allowAccess: ["SystemAdmin", "CustomerCareUser"],
            page: "admin",
          },
        },
        {
          path: "thanh-toan",
          name: "ThanhToan",
          redirect: "/admin/thanh-toan/danh-sach-thanh-toan",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-thanh-toan",
              name: "DanhSachThanhToan",
              component: DanhSachThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-thanh-toan/chi-tiet/:id",
              name: "ChiTietThanhToan",
              component: FormThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-thanh-toan/cap-nhat/:id",
              name: "CapNhatThanhToan",
              component: FormThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-thanh-toan/them-moi-thanh-toan",
              name: "ThemMoiThanhToan",
              component: FormThanhToan,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "san-pham",
          name: "SanPham",
          redirect: "/admin/san-pham/danh-sach-san-pham",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-san-pham",
              name: "DanhSachSanPham",
              component: DanhSachSanPham,
              meta: {
                allowAccess: [
                  "SystemAdmin",
                  "SalesManager",
                  "CustomerCareUser",
                ],
                page: "admin",
              },
            },
            {
              path: "san-pham/chi-tiet/:id",
              name: "ChiTietSanPham",
              component: FormSanPham,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "san-pham/cap-nhat/:id",
              name: "CapNhatSanPham",
              component: FormSanPham,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "san-pham/them-moi-san-pham",
              name: "ThemMoiSanPham",
              component: FormSanPham,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "thong-bao",
          name: "ThongBao",
          redirect: "/admin/thong-bao/danh-sach-thong-bao",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-thong-bao",
              name: "DanhSachThongBao",
              component: DanhSachThongBao,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-thong-bao/chi-tiet/:id",
              name: "ChiTietThongBao",
              component: FormThongBao,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-thong-bao/cap-nhat/:id",
              name: "CapNhatThongBao",
              component: FormThongBao,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-thong-bao/them-moi-thong-bao",
              name: "ThemMoiThongBao",
              component: FormThongBao,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "qr-scan",
          name: "QRScan",
          redirect: "/admin/qr-scan/danh-sach-qr-scan",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-qr-scan",
              name: "DanhSachQRScan",
              component: DanhSachQRScan,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-qr-scan/chi-tiet/:id",
              name: "ChiTietQRScan",
              component: FormQRScan,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-qr-scan/cap-nhat/:id",
              name: "CapNhatQRScan",
              component: FormQRScan,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-qr-scan/them-moi-qr-scan",
              name: "TaoQRScan",
              component: FormQRScan,
              meta: {
                allowAccess: ["SystemAdmin", "ContentAdmin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "mail",
          name: "TemplateMail",
          redirect: "/admin/mail/danh-sach-mail",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "danh-sach-mail",
              name: "DanhSachMail",
              component: DanhSachMail,
              meta: {
                allowAccess: [
                  "SystemAdmin",
                  "SalesManager",
                  "CustomerCareUser",
                ],
                page: "admin",
              },
            },
            {
              path: "danh-sach-mail/chi-tiet/:id",
              name: "ChiTietMail",
              component: MailForm,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-mail/cap-nhat/:id",
              name: "CapNhatMail",
              component: MailForm,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
            {
              path: "danh-sach-mail/them-moi",
              name: "ThemMoiMail",
              component: MailForm,
              meta: {
                allowAccess: ["SystemAdmin"],
                page: "admin",
              },
            },
          ],
        },
      ],
    },

    {
      path: "/auth",
      redirect: "/auth/login",
      name: "Auth",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      beforeEnter: (to, from, next) => {
        next();
      },
      children: [
        {
          path: "404",
          name: "Auth-Page404",
          component: AuthPage404,
          meta: {
            page: "auth",
          },
        },
        {
          path: "login",
          name: "Auth-Login",
          component: AuthLogin,
          meta: {
            page: "auth",
          },
        },
        {
          path: "recoverPassword",
          name: "Auth-RecoverPassword",
          component: AuthRecoverPassword,
          meta: {
            page: "auth",
          },
        },
        {
          path: "resetPassword",
          name: "Auth-ResetPassword",
          component: AuthResetPassword,
          meta: {
            page: "auth",
          },
        },
        {
          path: "sesstionTimeOut",
          name: "sesstionTimeOut",
          component: AuthTimeOut,
          meta: {
            page: "auth",
          },
        },
      ],
    },
  ],
});
export default router;
router.beforeEach(function (to, from, next) {
  // debugger
  if (from.name != to.name) {
    if (to.meta.page && to.meta.page == "admin") {
      next();
      AuthService.me()
        .then((res) => {
          window.localStorage.setItem(
            "currentUser",
            JSON.stringify(res.result)
          );
          next();
        })
        .catch((error) => {
          console.log(error);
          window.localStorage.clear();
          next({
            path: "/auth/login",
            query: { redirect: to.fullPath },
          });
        });
    } else if (to.meta.page && to.meta.page != "admin") {
      next();
    } else {
      next("/auth/login");
    }
  } else if (from.name && to.name && from.name == to.name) {
    next();
  } else {
    next("/auth/login");
  }
});
